import { FC } from "react";
import { SecondarySearch } from "src/Modules/Flights/Components";
import { FiltersBar, SortersBar } from "../components";
import { useJourneyListingContext } from "../context/JourneyListingContext";
import { JourneyType, DataGroupType } from "src/Modules/Flights/constants";
import JourneyListContent from "../components/JourneyList/components/JourneyListContent/JourneyListContent";
import CountdownTimerSlider from "@Components/CountdownTimerSlider/CountdownTimerSlider";
const JourneyListingMobile: FC<{
  fullDataGroups: DataGroupType;
  filteredGroups: DataGroupType;
  journies: JourneyType[];
}> = ({
  fullDataGroups,
  filteredGroups,
  journies,
}) => {
  const { isFetching, searchObject } = useJourneyListingContext();
  return (
    <div className="flex flex-col items-center justify-center gap-4 bg-background-default">
      <div className="sticky top-0 z-30 flex w-full flex-col rounded-b-sm bg-background-default shadow-md">
        <div className="w-full">
          <div className="flex w-full w-full flex-1 items-center justify-between gap-4 border-b border-border-default p-3">
            <div className="flex-1 flex-col">
              <SecondarySearch initialValues={searchObject} />
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-3 pb-2">
          <div className="w-full">
            <CountdownTimerSlider />
          </div>
          <div className="w-full bg-background-default px-5">
            <div className="flex items-center justify-between gap-3">
              <div className="w-full">
                <SortersBar dataGroups={filteredGroups} />
              </div>
              <div>
                <FiltersBar dataGroups={fullDataGroups} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex h-full w-full items-center justify-center p-3">
        <JourneyListContent isFetching={isFetching} journies={journies} />
      </div>
    </div>
  );
};

export default JourneyListingMobile;
